/**
 * @generated SignedSource<<3f276bb358672ea22a32b4b77bab5ba1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkNotificationAsReadInput = {
  clientMutationId?: string | null;
  notificationId: string;
};
export type NavBar2MarkNotificationAsReadMutation$variables = {
  input: MarkNotificationAsReadInput;
};
export type NavBar2MarkNotificationAsReadMutation$data = {
  readonly markNotificationAsRead: {
    readonly notification: {
      readonly id: string;
      readonly isRead: boolean;
    } | null;
    readonly ok: boolean | null;
  } | null;
};
export type NavBar2MarkNotificationAsReadMutation = {
  response: NavBar2MarkNotificationAsReadMutation$data;
  variables: NavBar2MarkNotificationAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkNotificationAsReadPayload",
    "kind": "LinkedField",
    "name": "markNotificationAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationNode",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRead",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavBar2MarkNotificationAsReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavBar2MarkNotificationAsReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f77ae323dc3a32571410da52aae7f41",
    "id": null,
    "metadata": {},
    "name": "NavBar2MarkNotificationAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation NavBar2MarkNotificationAsReadMutation(\n  $input: MarkNotificationAsReadInput!\n) {\n  markNotificationAsRead(input: $input) {\n    ok\n    notification {\n      id\n      isRead\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c8cf9f12b65ed93923e72b2d4dc0bb5";

export default node;
